import React, { useEffect } from "react";
import "./Notification.css";

const Notification = ({ message, onClose }) => {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, 3000); // auto-close after 3 seconds
    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="notification">
      {message}
    </div>
  );
};

export default Notification;
